export default __webpack_public_path__ + "static/media/loginbanner.2ea78fc7.jpg";